import { createApi, createStore } from "effector/compat";

export const $errors = createStore<Error | null>(null);

export const errorsApi = createApi($errors, {
  throw: (_, error: Error) => error,
  reset: () => null,
});
